import React, { useState } from 'react';
import { submitRegistration } from '../services/api';
import { generateCaptcha, Captcha } from './Captcha';

const TermsModal = ({ show, onClose }) => {
    if (!show) return null;
    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <br></br>
                    <button style={{ padding: "5px" }} type="button" className="btn-close" onClick={onClose}></button>
                    <div className="modal-header text-center">
                         <hr/>
                         <h5 className="modal-title text-center">شرایط و قوانین گارانتی</h5>                        
                    </div>
                    <div className="modal-body" dir="rtl">
                        <h6>مقررات و شرایط استفاده از خدمات گارانتی:</h6>
                        <ol>
                            <li>دستگاه های شامل گارانتی می بایست دارای شماره سریال و برچسب مخصوص باشند؛ بدیهی است خدمات و گارانتی محصولات بر اساس شماره سریال دستگاه صورت می گیرد.</li>
                            <li>جهت بهره مندی از خدمات و گارانتی محصولات؛ رعایت اصول و شرایط نصب صحیح دستگاه الزامی است و در غیر این صورت ضمن ابطال گارانتی؛ مجموعه فاقد هرگونه مسئولیتی می باشد .</li>
                            <li>جهت بهره‌مندی از گارانتی؛ معایب دستگاه می بایست مورد تایید تکنسین های متخصص مجموعه باشد .</li>
                            <li>پس از اتمام گارانتی تمامی خدمات با دریافت هزینه و طبق تعرفه مجموعه صورت می گیرد .</li>
                            <li>جهت بررسی اصالت کالا از <a href="https://query.miladcoolingindustry.com/">این لینک</a> استفاده فرمایید .</li>
                        </ol>
                        
                        <h6>در صورت بروز هرگونه مشکل باشماره های مجموعه تماس حاصل فرمایید</h6>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-warning" onClick={onClose}>
                            بستن
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const RegistrationForm = () => {
    const [formData, setFormData] = useState({
        productSerialNumber: '',
        personName: '',
        phoneNumber: '',
        captchaAnswer: '',
        acceptTerms: false
    });
    const [captcha, setCaptcha] = useState(generateCaptcha());
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [showTermsModal, setShowTermsModal] = useState(false);

    const handleInputChange = (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setFormData({
            ...formData,
            [e.target.name]: value
        });
    };

    const refreshCaptcha = () => {
        setCaptcha(generateCaptcha());
        setFormData(prev => ({ ...prev, captchaAnswer: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Frontend validation for terms acceptance
        if (!formData.acceptTerms) {
            setMessage({ type: 'danger', text: 'لطفاً شرایط و قوانین گارانتی را مطالعه و تایید کنید' });
            return;
        }

        setLoading(true);
        setMessage('');

        try {
            const submissionData = {
                ...formData,
                captchaQuestion: captcha.question
            };

            const result = await submitRegistration(submissionData);
            setMessage({ type: 'success', text: result.message });
            
            // Reset form
            setFormData({ 
                productSerialNumber: '', 
                personName: '', 
                phoneNumber: '',
                captchaAnswer: '',
                acceptTerms: false
            });
            refreshCaptcha();
        } catch (error) {
            setMessage({ type: 'danger', text: error.message || 'خطا در ارسال' });
        } finally {
            setLoading(false);
        }
    };

    const openTermsModal = () => {
        setShowTermsModal(true);
    };

    const closeTermsModal = () => {
        setShowTermsModal(false);
    };

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6 col-lg-5">
                    <div className="card shadow">
                        <div className="card-header bg-primary text-white text-center">
                            <h4 className="mb-0">سامانه فعال سازی گارانتی محصولات صنایع برودتی میلاد</h4>
                        </div>
                        <div className="card-body">
                            {message && (
                                <div className={`alert alert-${message.type} alert-dismissible fade show`}>
                                    {message.text}
                                    <button 
                                        type="button" 
                                        className="btn-close"
                                        onClick={() => setMessage('')}
                                    ></button>
                                </div>
                            )}

                            <form onSubmit={handleSubmit} dir="rtl">
                                {/* Product Serial Number */}
                                <div className="mb-3">
                                    <label htmlFor="productSerialNumber" className="form-label">
                                       * شماره سریال محصول
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="productSerialNumber"
                                        name="productSerialNumber"
                                        value={formData.productSerialNumber}
                                        onChange={handleInputChange}
                                        required
                                        dir="ltr"
                                        placeholder="IR123456...."
                                    />
                                </div>

                                {/* Person Name */}
                                <div className="mb-3">
                                    <label htmlFor="personName" className="form-label">
                                        نام/نام خانوادگی
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="personName"
                                        name="personName"
                                        value={formData.personName}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="آقا/خانم ...."
                                    />
                                </div>

                                {/* Phone Number */}
                                <div className="mb-3">
                                    <label htmlFor="phoneNumber" className="form-label">
                                        تلفن تماس
                                    </label>
                                    <input
                                        type="tel"
                                        className="form-control"
                                        id="phoneNumber"
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        onChange={handleInputChange}
                                        required
                                        dir="ltr"
                                        placeholder="09123456789"
                                        pattern="[0-9+\-\s()]{10,20}"
                                    />
                                    <div className="form-text">شماره تماس خود را به دقت وارد کنید.</div>
                                </div>  

                                {/* CAPTCHA */}
                                <Captcha captcha={captcha} onRefresh={refreshCaptcha} />

                                <div className="mb-3">
                                    <label htmlFor="captchaAnswer" className="form-label">
                                        پاسخ
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="captchaAnswer"
                                        name="captchaAnswer"
                                        value={formData.captchaAnswer}
                                        onChange={handleInputChange}
                                        required
                                        dir="ltr"
                                        placeholder=""
                                    />
                                </div>

                                {/* Terms and Conditions */}
                                <div className="mb-3">
                                    <div className="form-check d-flex align-items-center gap-2" dir="rtl">
                                        <input
                                            className="form-check-input"
                                            style={{ padding:"5px"}}
                                            type="checkbox"
                                            id="acceptTerms"
                                            name="acceptTerms"
                                            checked={formData.acceptTerms}
                                            onChange={handleInputChange}
                                            required
                                        />
                                        <label className="form-check-label text-nowrap" htmlFor="acceptTerms"
                                        style={{ padding:"5px" , marginRight:"25px"}}
                                        >
                                            <span>با </span>
                                            <button
                                                type="button"
                                                className="btn btn-link p-0 align-baseline"
                                                onClick={openTermsModal}
                                                style={{ textDecoration: 'underline'                                                       
                                                }}
                                            >
                                                شرایط و قوانین گارانتی
                                            </button>
                                            <span> موافقم</span>
                                        </label>
                                    </div>
                                </div>

                                <button 
                                    type="submit" 
                                    className="btn btn-primary w-100 py-2"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" />
                                            ارسال
                                        </>
                                    ) : (
                                       'ارسال'
                                    )}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* Terms and Conditions Modal */}
            <TermsModal show={showTermsModal} onClose={closeTermsModal} />
        </div>
    );
};

export default RegistrationForm;